import { render, staticRenderFns } from "./SpaceFilters.vue?vue&type=template&id=a4e5eae4"
import script from "./SpaceFilters.vue?vue&type=script&lang=js"
export * from "./SpaceFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports